module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-components/customer-detail/customer-detail.component.scss
// module id = ./src/app/customer-components/customer-detail/customer-detail.component.scss
// module chunks = main